import { Inject, Injectable, ModuleWithProviders, NgModule, PLATFORM_ID } from '@angular/core';
import { Storage } from '@ionic/storage';
import { CoreOptions } from '../interfaces/core-options.interface';
import { installState } from '../state/install-state';
import { installStorage } from '../storage/install-storage';
import { storageConfig } from '../storage/storage-config';
import { applyDevTools } from '../store/apply-dev-tools';
import { createStore } from '../store/create-store';
import { Core } from './core';

@Injectable()
export class CoreSetup {
    constructor(@Inject('CoreSetup') public options: CoreOptions, @Inject(PLATFORM_ID) private platformId: Object) {
        //
        // Set options
        for (const k in options) {
            (<any>Core).options[k] = (<any>options)[k];
        }

        //
        // Install storage
        installStorage(new Storage(storageConfig(options.dbName, options.dbStore), this.platformId));

        //
        // Install store
        installState();
        createStore((options && options.reducers) || {}, (options && options.state) || {}, applyDevTools(options));
    }
}

/**
    Stored Module 
    @example
    ```js
    import { StoredModule } from '@mtda/stored';
    //... 
    StoredModule.forRoot({
      name: '', // define default collection name. eg: 'todos'
      silent: false, // whether show logs
      useCache: false // difine default `cache()` value
      useMemo: false // difine default `memo()` value
      useObservable: of() // difine default `observable()` value
      persistence: false  // difine default `persistense` value
    })
    //...
    ```
    @export
    @class StoredModule
  */
@NgModule()
export class StoredModule {
    public static forRoot(options: CoreOptions = {}): ModuleWithProviders<StoredModule> {
        return {
            ngModule: StoredModule,
            providers: [
                CoreSetup,
                {
                    provide: 'CoreSetup',
                    useValue: options,
                },
            ],
        };
    }
    constructor(private angular: CoreSetup) {}
}
